export default __webpack_public_path__ + "static/media/office2-afterB.33f137c7.jpg";